import { UnitType } from '@eventops/athlinks-lib-units';
import i18n from '../utils/i18n';

export const UserPrefsState = {
  globalUnitType: UnitType.DEFAULT,
  language: i18n.language
};
